import React, { useState } from 'react';

const milestones = [
{
  year: '2019',
  month: 'JANUAR',
  title: 'Idéen fødes',
  desc: 'Erik Nordmann og Astrid Bergström møtes på en konferanse om digital infrastruktur. De innser at norske sjåfører mangler et moderne verktøy for veinavigasjon og bomberegning.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_18e41b4de-1772191889090.png",
  alt: 'Two people having a conversation at a technology conference with Norwegian city backdrop'
},
{
  year: '2019',
  month: 'SEPTEMBER',
  title: 'NordPass AS stiftes',
  desc: 'Selskapet registreres i Oslo. De første tre ansatte begynner arbeidet med å bygge plattformens tekniske fundament og kartdataintegrasjoner.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_11528d9ed-1772191891968.png",
  alt: 'Modern Oslo office space with team members working on computers and whiteboards'
},
{
  year: '2020',
  month: 'MARS',
  title: 'Beta-lansering',
  desc: 'NordPass beta lanseres for 500 utvalgte testbrukere. Tilbakemeldingene er overveldende positive, og teamet jobber intenst med å forbedre brukeropplevelsen.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_194e0fba3-1772191886839.png",
  alt: 'Dashboard interface on laptop screen showing Norwegian road map with toll calculation results'
},
{
  year: '2021',
  month: 'JUNI',
  title: 'Offentlig lansering',
  desc: 'NordPass åpner for alle norske brukere. Innen tre måneder har plattformen 10.000 registrerte brukere og dekker alle norske bomstasjoner.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_12ca91990-1772191888910.png",
  alt: 'Norwegian highway with toll station and modern cars passing through at sunset'
},
{
  year: '2022',
  month: 'NOVEMBER',
  title: 'AutoPASS-integrasjon',
  desc: 'NordPass integrerer direkte med AutoPASS-systemet, noe som gir brukerne sanntids rabattberegninger og automatisk kjøretøygjenkjenning.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_17b90ee56-1772191894544.png",
  alt: 'Close-up of AutoPASS transponder on car windshield with Norwegian road in background'
},
{
  year: '2024',
  month: 'APRIL',
  title: '47.000 brukere',
  desc: 'NordPass passerer 47.000 aktive brukere og lanserer premium-abonnementet med avanserte funksjoner for profesjonelle sjåfører og transportselskaper.',
  img: "https://img.rocket.new/generatedImages/rocket_gen_img_15b55d44a-1772191890807.png",
  alt: 'Aerial view of Norwegian road network with multiple vehicles showing growth and scale'
}];


const TimelineSection = () => {
  const [activeItem, setActiveItem] = useState(0);

  return (
    <section style={{ background: '#050A12', padding: '120px 0', position: 'relative', overflow: 'hidden' }}>
      {/* Background image strip */}
      <div style={{
        position: 'absolute',
        top: 0, right: 0,
        width: '40%',
        height: '100%',
        overflow: 'hidden',
        opacity: 0.15
      }}>
        <img
          src="https://img.rocket.new/generatedImages/rocket_gen_img_1816db288-1772191886845.png"
          alt="Norwegian mountain road landscape background texture"
          style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        
      </div>
      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 5%', position: 'relative', zIndex: 1 }}>
        {/* Header */}
        <div style={{ marginBottom: '80px' }}>
          <div style={{
            fontFamily: 'JetBrains Mono, monospace',
            fontSize: '0.6875rem',
            color: '#3B6FD4',
            letterSpacing: '0.2em',
            textTransform: 'uppercase',
            marginBottom: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }}>
            <div style={{ width: '32px', height: '1px', background: '#3B6FD4' }} />
            VÅR HISTORIE
          </div>
          <h2 style={{
            fontFamily: 'Syne, sans-serif',
            fontSize: 'clamp(2rem, 4vw, 3.5rem)',
            fontWeight: 800,
            color: '#EEF0F2',
            letterSpacing: '-0.04em',
            lineHeight: 1,
            margin: 0
          }}>
            FRA IDÉ TIL
            <br /><span style={{ color: '#3B6FD4' }}>NORGES VEIER</span>
          </h2>
        </div>

        {/* Timeline layout */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '60px', alignItems: 'start' }}>
          {/* Timeline nav */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
            {milestones?.map((m, i) =>
            <div
              key={i}
              onClick={() => setActiveItem(i)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '20px',
                padding: '20px 0',
                cursor: 'pointer',
                borderBottom: '1px solid rgba(255,255,255,0.04)',
                opacity: activeItem === i ? 1 : 0.4,
                transition: 'opacity 200ms ease'
              }}>
              
                <div style={{
                width: '12px',
                height: '12px',
                background: activeItem === i ? '#3B6FD4' : 'transparent',
                border: '2px solid',
                borderColor: activeItem === i ? '#3B6FD4' : 'rgba(255,255,255,0.2)',
                borderRadius: '50%',
                flexShrink: 0,
                transition: 'all 200ms ease'
              }} />
                <div>
                  <div style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.75rem', color: '#3B6FD4', letterSpacing: '0.1em' }}>{m?.year} — {m?.month}</div>
                  <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.9375rem', fontWeight: 700, color: '#EEF0F2', marginTop: '2px' }}>{m?.title}</div>
                </div>
              </div>
            )}
          </div>

          {/* Active milestone detail */}
          <div>
            <div style={{ position: 'relative', overflow: 'hidden', marginBottom: '32px' }}>
              <img
                src={milestones?.[activeItem]?.img}
                alt={milestones?.[activeItem]?.alt}
                style={{ width: '100%', height: '320px', objectFit: 'cover', filter: 'brightness(0.7) contrast(1.1)' }} />
              
              <div style={{
                position: 'absolute',
                bottom: 0, left: 0, right: 0,
                padding: '24px',
                background: 'linear-gradient(to top, rgba(5,10,18,0.9), transparent)'
              }}>
                <div style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.6875rem', color: '#3B6FD4', letterSpacing: '0.15em' }}>
                  {milestones?.[activeItem]?.year} — {milestones?.[activeItem]?.month}
                </div>
              </div>
            </div>
            <h3 style={{
              fontFamily: 'Syne, sans-serif',
              fontSize: 'clamp(1.5rem, 2.5vw, 2rem)',
              fontWeight: 800,
              color: '#EEF0F2',
              letterSpacing: '-0.03em',
              marginBottom: '16px'
            }}>{milestones?.[activeItem]?.title}</h3>
            <p style={{
              fontFamily: 'Lora, serif',
              fontSize: '1.0625rem',
              color: 'rgba(238,240,242,0.7)',
              lineHeight: 1.8
            }}>{milestones?.[activeItem]?.desc}</p>
          </div>
        </div>
      </div>
    </section>);

};

export default TimelineSection;